/** @format */

import {Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import {sharedClasses} from '../KpiSection/sharedStyles';

export {
  ChartArea,
  ForecastLabel,
  RowLabel,
  RowValue,
  SummaryGrid,
} from '../KpiSection/sharedStyles';

// Re-export sharedClasses as `classes` so consumers keep the same import unchanged.
export const classes = sharedClasses;

// Section label "Расход" — 16px / 20px medium, onSurface (mirrors KpiLabel).
export const SpendLabel = styled(Typography)(({theme}) => ({
  fontSize: 16,
  lineHeight: '20px',
  fontWeight: 500,
  color: theme.palette.semantic_dark?.surface.onSurface,
  whiteSpace: 'nowrap',
}));
